//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { injectError } from 'common/redux/actions/error';
import { ApiError } from 'common/modules/api';
import { selectFactory } from 'common/components/core/select';
import theme from './EffectiveStatusDropdown.scss';
import { contractEffectiveStatusApi } from 'common/middleware/api';
import { renderNull } from 'common/utils/ReactUtils';
import EffectiveStatusButton from './EffectiveStatusButton';
import EffectiveStatusOptions from './EffectiveStatusOptions';
import { translate, type TFunction } from 'react-i18next';
import { type ContractStatusEnum } from 'common/models/flow/MasterContract';

const Select = selectFactory({
    Option: EffectiveStatusOptions,
    Control: EffectiveStatusButton,
    Placeholder: renderNull,
    SingleValue: renderNull,
    IndicatorsContainer: renderNull
});

type OwnProps = {
    options: Array<ContractStatusEnum>,
    value: ContractStatusEnum,
    clientId: string,
    contractId: string,
    disabled: boolean,
    fetchContractVersions: ({ contractId: string, clientId: string }) => void
};

type Props = {
    ...OwnProps,
    t: TFunction,
    injectError: ApiError => void
};

type State = {
    isLoading: boolean
};

class EffectiveStatusDropdown extends React.Component<Props, State> {
    state = {
        isLoading: false
    };

    onSelect = selected => {
        const {
            clientId,
            contractId,
            fetchContractVersions,
            injectError
        } = this.props;
        const body = {
            effectiveStatus: selected.value
        };
        this.setState({ isLoading: true });
        return contractEffectiveStatusApi
            .post({ clientId, contractId }, body)
            .then(() => {
                fetchContractVersions({ contractId, clientId });
            })
            .catch(error => {
                if (error instanceof ApiError) {
                    injectError(error);
                } else {
                    throw error;
                }
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    };

    render() {
        const { value, options, disabled, t } = this.props;
        const { isLoading } = this.state;
        const translatedOptions = options.map(option => ({
            label: t(`masterContractProperties.effectiveStatuses.${option}`),
            value: option
        }));
        return (
            <Select
                theme={theme}
                isClearable={false}
                isSearchable={false}
                options={translatedOptions}
                buttonLabel={t(
                    `masterContractProperties.effectiveStatuses.${value}`
                )}
                buttonValue={value}
                onChange={this.onSelect}
                isLoading={isLoading}
                disabled={disabled}
            />
        );
    }
}

const mapDispatchToProps = dispatch => {
    return { injectError: error => dispatch(injectError(error)) };
};

const withRedux = connect(null, mapDispatchToProps);

export default (compose(
    withRedux,
    translate('entityManagement')
)(EffectiveStatusDropdown): React.AbstractComponent<OwnProps>);
